<p style="margin: 0px auto; padding: 0px; color: rgba(255, 255, 255, 0.541176); max-width: 356px;"><!-- react-text: 103 -->
  Hand crafted with love by <!-- /react-text -->
  <a href="https://github.com/bfwg" style="color: rgba(255, 255, 255, 0.870588);">Fan Jin</a>
  <!-- react-text: 105 --> and our awesome <!-- /react-text -->
  <a href="https://github.com/bfwg/angular-spring-jwt-starter/graphs/contributors" style="color: rgba(255, 255, 255, 0.870588);">contributors</a><!-- react-text: 107 -->.<!-- /react-text -->
</p>
<a style="margin-top: 22px;" mat-icon-button href="https://github.com/bfwg/angular-spring-jwt-starter">
  <img src="assets/image/github.png"/>
</a>
